import uuid from 'uuid';

export const DEFAULT_CAMPAIGN_FORM_DATA = {
  campaignId: uuid.v4(),
  isValid: false,
  content: {
    name: '',
    id: '',
  },
  segment: {
    segmentId: '',
    segmentName: '',
  },
  platform: {
    channel: '',
  },
  schedule: {
    endTime: '',
    frequency: '',
    startTime: '',
    timeZone: '',
  },
};

export const CSV_MIME_TYPE = 'text/csv';
